import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "115",
  height: "131",
  viewBox: "0 0 115 131",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      opacity: ".4",
      d: "M1.818 65.13c0 17.638 0 35.279.003 52.918 0 7.054 4.08 11.131 11.167 11.131 29.81.009 59.622.009 89.435.003 7.187-.003 11.214-4.062 11.217-11.289 0-24.36-.104-48.722.083-73.083.038-4.948-1.342-9.111-4.086-13.031-4.72-6.744-10.216-12.812-16.388-18.213-4.04-3.535-8.414-6.705-12.781-9.843-2.471-1.778-5.378-2.368-8.498-2.356-19.629.074-39.26.036-58.89.039-7.268 0-11.259 3.97-11.259 11.209-.003 17.505-.003 35.01-.003 52.514h0Z",
      stroke: "#000",
      "stroke-opacity": ".87",
      "stroke-width": "2.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M93.67 101.433H20.874V35.031h6.054V95.38h66.74v6.054Z",
      fill: "#FDC723",
      opacity: ".4"
    }, null, -1),
    _createElementVNode("path", {
      d: "m57.184 91.525-14.04-14.194-7.839 10.89-4.912-3.538 12.021-16.699 13.248 13.394 17.292-33.046 8.92 13.414 9.433-.389.248 6.048-12.835.53-5.144-7.735-16.391 31.325Z",
      fill: "#FDC723",
      opacity: ".4"
    }, null, -1)
  ]))]))
}
export default { render: render }